<template>
  <transition name="fade">
    <div
      id="full-screen-loading"
      class="view-loading-screen fade-effect text-light"
      :style="{ 'animation-play-state': visible ? 'paused' : 'running' }"
    >
      <div
        id="content-loading"
        class="d-flex flex-column justify-content-center align-items-center"
      >
        <img
          class="mb-9"
          src="@/assets/images/logo-icon.svg"
          alt="Logo Blitz pay"
        />
        <h4 class="mb-6">
          Carregando...
        </h4>
        <div class="w-75 text-center">
          {{ text }}
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      default: ""
    },
    seconds: {
      type: Number,
      default: 4000
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.open();
      } else {
        setTimeout(() => {
          this.close();
        }, 4000);
      }
    }
  },
  mounted() {
    if (this.visible) {
      this.open();
    }
  },
  methods: {
    open() {
      document.getElementById("full-screen-loading").style.display = "block";
    },
    close() {
      document.getElementById("full-screen-loading").style.display = "none";
      this.$emit("close");
    }
  }
};
</script>
<style lang="scss" scoped>
.view-loading-screen {
  position: fixed;
  display: none;
  z-index: 1000;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background: #393444;
  animation-name: fadein;
  animation-duration: 4s;
  @keyframes fadein {
    0% {
      opacity: 1;
    }
    25% {
      opacity: 1;
    }
    50% {
      opacity: 0.8;
    }
    75% {
      opacity: 0.4;
    }
    100% {
      opacity: 0.2;
      display: none;
    }
  }

  img {
    height: 70px;
  }

  #content-loading {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>
